// export default VisitorsList;
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import icondeleteDevise from "../../assets/delete.png";
import iconSearch from "../../assets/Search.png";
import ClientLayout from "../../component/appLayouts/clientLayout/clientLayout";
import { useAuth } from "../../component/authProvider";
import DataTableDisplay from "../../component/ListeDevis/ListeDevis";
import ResponsiveCard from "../../component/ResponsiveCards";
import {
  deleteClientAndDevis,
  getVisitors,
  updateUser,
} from "../../services/user.service";
import AcceptIcon from "../icons/acceptIcon";
function VisitorsList() {
  const [visitors, setVisitors] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const isMobile = window.innerWidth <= 768;

  const columns = [
    {
      name: "Prénom",
      selector: (row) => row.firstname,
      sortable: true,
    },
    {
      name: "Nom",
      selector: (row) => row.lastname,
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="d-flex gap-2">
          <button
            type="button"
            className="btn-link detailsbutton p-0"
            style={{ borderRadius: "14px" }}
            onClick={() => {
              if (row && row._id) {
                navigate(`/viewUser/${row._id}`);
              }
            }}>
            <label className="action-icon detailsicons" title="View Details">
              Détails
            </label>
          </button>
          <button
            style={{
              borderRadius: "6px",
              backgroundColor: "var(--primary-color)",
              width: "40px",
              height: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "none",
              padding: "0",
            }}
            onClick={() => handleAcceptVisitor(row._id)}>
            <AcceptIcon />
          </button>

          <button
            className="delete-devise-user"
            onClick={() => handleDeleteClient(row._id)}
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "6px",
              backgroundColor: "transparent",
              border: "none",
              padding: "0",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}>
            <img
              src={icondeleteDevise}
              alt="delete"
              style={{ width: "20px", height: "20px" }}
            />
          </button>
        </div>
      ),
    },
  ];

  // Récupération des visiteurs
  const fetchVisitors = async () => {
    try {
      const allUsers = await getVisitors();
      const visiteursOnly = allUsers.filter(
        (u) => u?.Role?.toLowerCase() === "visitor"
      );
      setVisitors(visiteursOnly);
    } catch (err) {
      console.error("Erreur de récupération des visiteurs", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVisitors();
  }, []);

  // Filtrage des visiteurs selon la recherche
  useEffect(() => {
    const lowerQuery = searchQuery.toLowerCase();
    const filtered = visitors.filter((user) =>
      `${user.firstname} ${user.lastname} ${user.Role}`
        .toLowerCase()
        .includes(lowerQuery)
    );
    setFilteredData(filtered);
  }, [searchQuery, visitors]);

  // Accepter un visiteur (changer le rôle en "client")
  const handleAcceptVisitor = async (userId) => {
    try {
      await updateUser(userId, { Role: "client" });
      toast.success("Visiteur accepté comme client !");
      fetchVisitors(); // Rafraîchir la liste
    } catch (error) {
      toast.error("Erreur lors de l'acceptation du visiteur.");
      console.error("Erreur lors de l'acceptation du visiteur :", error);
    }
  };
  // Supprimer un visiteur
  const handleDeleteClient = async (id) => {
    const confirmDelete = window.confirm(
      "Supprimer ce visiteur et ses devis ?"
    );
    if (confirmDelete) {
      try {
        // Call the deleteClientAndDevis function to delete both the user and their devis
        await deleteClientAndDevis(id);

        // Remove the deleted user from the state
        setVisitors((prev) => prev.filter((c) => c._id !== id));

        // Optionally, if you have a devis state, update it here too
        // setDevis((prevDevis) => prevDevis.filter((devis) => devis.clientId !== id));
      } catch (err) {
        console.error("Erreur de suppression", err);
      }
    }
  };

  return (
    <ClientLayout>
      <div className="clients-page p-3">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h3 className="mb-0">Liste des Demandes </h3>
          {/* Recherche */}
          <div className="d-flex gap-3 align-items-center">
            <div className="search-container py-3">
              <div className="search-input-wrapper position-relative">
                <img
                  src={iconSearch}
                  alt="search icon"
                  className="search-icon"
                />
                <input
                  type="text"
                  className="form-control ps-5 pe-5"
                  placeholder="Rechercher ... "
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Liste des visiteurs */}
        <div className="container-fluid py-5">
          <div className="col-12">
            <div className="card-body">
              {loading ? (
                <div>Chargement des visiteurs...</div>
              ) : filteredData.length === 0 ? (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ height: "200px" }}>
                  Aucune demande trouvée.
                </div>
              ) : isMobile ? (
                <ResponsiveCard
                  data={filteredData}
                  onAccept={(user) => handleAcceptVisitor(user._id)}
                  onDelete={(user) => handleDeleteClient(user._id)}
                  onEdit={(user) => {
                    setSelectedUser(user);
                    setIsEditModalOpen(true);
                  }}
                />
              ) : (
                <DataTableDisplay data={filteredData} columns={columns} />
              )}
            </div>
          </div>
        </div>

        {/* Modal d'édition */}
        {/* {isEditModalOpen && selectedUser && (
          <EditClient
            show={isEditModalOpen}
            handleClose={() => {
              setIsEditModalOpen(false);
              setSelectedUser(null);
            }}
            user={selectedUser}
            onUserUpdated={() => {
              fetchVisitors();
              setIsEditModalOpen(false);
              setSelectedUser(null);
            }}
          />
        )} */}

        <ToastContainer autoClose={3000} />
      </div>
    </ClientLayout>
  );
}

export default VisitorsList;
